export default {
  // Hero
  build: 'Current build 2.6.1',
  heroTitle1: 'Verified game keys.',
  heroTitle2: 'Zero latency delivery.',
  heroSubtitle:
    'Gain immediate access to premium gaming titles. Our brutalist infrastructure ensures secure transactions and instant key dispatch directly to your terminal.',
  browseCatalog: 'Browse catalog',
  howItWorks: 'How it works',

  // Live metrics panel
  liveMetrics: 'Live metrics',
  titles: 'Titles',
  activePlayers: 'Active players',
  delivery: 'Delivery',
  verified: 'Verified',

  // Sections
  topPicks: 'Top picks',
  featuredThisWeek: 'Featured this week',
  viewAll: 'View all',
  selectPlatform: 'Select platform',
  addToCart: 'Add to cart',
  baseGame: 'Base game',
  dlc: 'DLC',
  titlesShort: 'titles',

  // How it works
  howHeading1: 'Three steps.',
  howHeading2: 'Zero friction.',
  howSubtitle: 'From browse to activated key in under a minute.',
  step1Title: 'Pick',
  step1Body: 'Select your desired title from our verified database.',
  step2Title: 'Pay',
  step2Body: 'Execute secure transaction via encrypted channels.',
  step3Title: 'Receive',
  step3Body: 'Key dispatched instantly to your terminal.',

  // Stats strip
  statPlayers: 'Players',
  statTitles: 'Titles',
  statDelivery: 'Delivery',
  statFailure: 'Failure',

  // States
  loading: 'Loading catalog…',
  empty: 'No listings available right now.',
};
